// PDP 面料养护：阶段标签（Wash / Dry / Iron）和机洗 / 手洗切换共用同一套 ARIA tabs 逻辑。
// 初始选中状态由 Liquid 输出，这里只负责切换和键盘（左右 / Home / End 自动激活）。
if (!customElements.get('care-guide-tabs')) {
  customElements.define('care-guide-tabs', class CareGuideTabs extends HTMLElement {
    constructor() {
      super();
      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeydown);
    }

    tabsOf(tab) {
      const list = tab.closest('[role="tablist"]');
      return list ? Array.from(list.querySelectorAll(':scope > [role="tab"]')) : [];
    }

    select(tab, focus) {
      this.tabsOf(tab).forEach((item) => {
        const selected = item === tab;
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
        const panel = document.getElementById(item.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      });
      if (focus) tab.focus();
    }

    onClick(event) {
      const tab = event.target.closest('[role="tab"]');
      if (tab && this.contains(tab)) this.select(tab, false);
    }

    onKeydown(event) {
      const tab = event.target.closest('[role="tab"]');
      if (!tab || !this.contains(tab)) return;
      const tabs = this.tabsOf(tab);
      const index = tabs.indexOf(tab);
      const next = {
        ArrowRight: tabs[(index + 1) % tabs.length],
        ArrowLeft: tabs[(index - 1 + tabs.length) % tabs.length],
        Home: tabs[0],
        End: tabs[tabs.length - 1],
      }[event.key];
      if (!next) return;
      event.preventDefault();
      this.select(next, true);
    }
  });
}
